/* eslint-disable @typescript-eslint/no-explicit-any */

import { IFinalResponse, XEventData, XStateMachine } from '_core/types';
import EventsHelper from '../config/events/EventsHelper';
import { IMachine } from './constants';
import { xstateInterpreter } from './handlersXstate';

export const callServiceMachine = (
  machine: XStateMachine<any, any, any>,
  params?: XEventData,
  nameService?: string,
): Promise<IFinalResponse> =>
  new Promise((resolve) => {
    try {
      const machineService = xstateInterpreter(machine);

      machineService.start();
      machineService.send(IMachine.START, { ...params });

      machineService.onTransition((state) => {
        if (nameService !== undefined) {
          EventsHelper.emitMessage(nameService, state.value);
        }

        if (state.value === IMachine.FINISH) {
          resolve(state.context.finalResponse);
          machineService.stop();
        }
      });
    } catch (error) {
      resolve({
        entity: 'MachineExpection',
        data: null,
        errors: error,
        success: false,
      });
    }
  });
